export default {
  favoriteList: {
    status: 0,
    items: [],
    currentPage: 1,
  },
  orderList: {
    all: {
      status: 0,
      data: {
        items: [],
        p: 1,
        timeLimit: null,
        totalItem: '0',
        isMore: 0,
      },
    },
    unpayed: {
      status: 0,
      data: {
        items: [],
        p: 1,
        timeLimit: null,
        totalItem: '0',
        isMore: 0,
      },
    },
    canceled: {
      status: 0,
      data: {
        items: [],
        p: 1,
        timeLimit: null,
        totalItem: '0',
        isMore: 0,
      },
    },
    shipped: {
      status: 0,
      data: {
        items: [],
        p: 1,
        timeLimit: null,
        totalItem: '0',
        isMore: 0,
      },
    },
    completed: {
      status: 0,
      data: {
        items: [],
        p: 1,
        timeLimit: null,
        totalItem: '0',
        isMore: 0,
      },
    },
  },
  addressList: {
    status: 0,
    data: [],
  },
};
